import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { DialogComponentContext } from './contexts';
import { usePage } from '~/__modules__/page';

const rootElem = document.getElementById('modal-root');
const style = { overflowX: 'auto' };

Dialog.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
export default function Dialog({
  icon,
  title,
  description,
  onClose,
  children,
}) {
  const { t } = useTranslation();
  const { language } = usePage();

  const elemRef = useRef();
  useEffect(() => {
    const buttonElem = elemRef.current.querySelector('.btn_area button');
    if (buttonElem) buttonElem.focus();
  }, []);

  return ReactDOM.createPortal(
    <div
      ref={elemRef}
      className={classNames('ly_wrap', 'dimmed', language)}
      style={style}
    >
      <div className="ly_common">
        {!_.isEmpty(icon) && (
          <i className={`ico_${icon}`}>{t(`icon_${icon}`)}</i>
        )}
        <h3 className="title">{title}</h3>
        {!_.isEmpty(description) && <p className="desc">{description}</p>}
        <div className="btn_area">
          <DialogComponentContext.Provider value={{ onClose }}>
            {children}
          </DialogComponentContext.Provider>
        </div>
      </div>
    </div>,
    rootElem,
  );
}
Dialog.Alert = AlertDialog;
Dialog.Confirm = ConfirmDialog;

function AlertDialog(dialogProps) {
  return <Dialog {...dialogProps} icon="alert" />;
}

function ConfirmDialog(dialogProps) {
  return <Dialog {...dialogProps} icon="confirm" />;
}
